import { filter } from 'lodash';
import axios from 'axios';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton
} from '@material-ui/core';

import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { baseUrl } from '../../utils/constants';
import { useAccountingContext } from '../../context/accounting_context';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'tarrifC', label: 'Ref Id', alignRight: true },
  { id: 'payment', label: 'AHFOZ #', alignRight: true },
  { id: 'status', label: 'Member #', alignRight: true },
  { id: 'tariff', label: 'Debit Award', alignRight: true },
  { id: 'ref', label: 'Credit Award', alignRight: true },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function JournalSelfAnalysis() {
  const { refIdSelf, getAnalysisSelfById, analysisSelfList, setAnalysisSelfList } =
    useAccountingContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(4);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {
    if (refIdSelf > 0) getAnalysisSelfById(refIdSelf);
    else setAnalysisSelfList([]);
    console.log('refId no in effect', refIdSelf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('refIdSelf effect', refIdSelf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [analysisSelfList]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleLoanView = (e) => {
    console.log('e loanRefid', e);
    // setLoanRefId(e.refId);
    // getLoanTransactionResults(customerIdentifier, e.refId);
    // openView();
  };

  const openView = (e) => {
    navigate(`/loans/loanDetails/${e}`);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - analysisSelfList.length) : 0;

  const filteredUsers = applySortFilter(
    analysisSelfList,
    getComparator(order, orderBy),
    filterName
  );

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Card>
        <Scrollbar>
          <TableContainer>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={analysisSelfList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      refId,
                      claimNo,
                      membershipNo,
                      creditor,
                      debitAward,
                      creditAward,
                      namasNo
                    } = row;
                    const isItemSelected = selected.indexOf(refId) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={refId}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="right">{refId}</TableCell>
                        <TableCell align="right">{namasNo}</TableCell>
                        <TableCell align="right">{membershipNo}</TableCell>
                        <TableCell align="right">{debitAward.toFixed(2)}</TableCell>
                        <TableCell align="right">{creditAward.toFixed(2)}</TableCell>
                        {/* <TableCell align="right">
                          <IconButton onClick={() => handleLoanView({ refId })}>
                            <VisibilityIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                        </TableCell> */}
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[4, 8, 12]}
          component="div"
          count={analysisSelfList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
